import React from 'react';
import { ObservableMap } from 'mobx';
import { observer, inject } from 'mobx-react';

import { SectionLayout } from 'layouts/section';
import { LectureComponent as Lecture } from 'components/lecture';
import { SelectComponent as Select } from 'components/select';
import { CardBackgroundComponent as Card } from 'components/cards';

import background from 'static/images/classroom.jpg';

import styles from './lectures-page.styles.scss';


const LABELS = new ObservableMap({
  date: 'Datum',
  fee: 'Preis',
  seats: 'Plätze',
  title: 'Titel',
  venue: 'Veranstaltungsort',
});


@inject('analyticsStore', 'lecturesStore')
@observer
export class LecturesPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/lectures');
  }

  constructor(props) {
    super(props);

    this.state = {
      filter: 'all',
      sortBy: 'date',
      sortDirection: 'asc'
    };
  }

  render() {
    return (
      <div className={styles.LecturesPage}>
        <SectionLayout  background={background}>
          <Card className={styles.Card}>
            <h1>Seminare</h1>
            <p>
              Viel Spaß beim Stöbern in den aktuellen Seminarangeboten. Sollte Sie ein Thema ohne aktuellen Termin interessieren, melden Sie sich bitte. Die Seminare rotieren regelmäßig und Sie werden selbstverständlich über neue Termine informiert.
            </p>
          </Card>
        </SectionLayout>

        <SectionLayout>
          <div className={styles.Filters}>
            { this.renderFilters() }
            { this.renderSorting() }
          </div>
          {
            this.lectures.map((lecture) => (
              <Lecture
                key={lecture.id}
                className={styles.Lecture}
                lecture={lecture}
              />
            ))
          }
        </SectionLayout>
      </div>
    );
  }

  renderFilters() {
    const baseOptions = [{ value: 'all', label: 'Alle Kategorien' }];
    const options = [ ...baseOptions, ...this.props.lecturesStore.options$ ];
    return (
      <Select
        name='tags'
        value={this.state.filter}
        onChange={this.onChangeTags}
        className={styles.Select}
        options={options}
      />
    );
  }

  renderSorting() {
    const { sortingAvailable$ } = this.props.lecturesStore;
    const sortingOptions = sortingAvailable$.map((field, idx) => (
      { value: field, label: LABELS.get(field) }
    ));
    const directionOptions = [{
      value: 'asc', label: 'aufsteigend'
    }, {
      value: 'desc', label: 'absteigend'
    }];

    return (
      <React.Fragment>
        <Select
          name='sortBy'
          value={this.state.sortBy}
          onChange={this.onChangeSortBy}
          className={styles.Select}
          options={sortingOptions}
        />
        <Select
          value={this.state.sortDirection}
          onChange={this.onChangeSortDirection}
          className={styles.Select}
          options={directionOptions}
        />
      </React.Fragment>
    );
  }

  applyFilters(lectures) {
    const { lecturesStore } = this.props;
    const { filter } = this.state;
    if (lecturesStore.tags$.includes(filter)) {
      lectures = lectures.filter((lecture) => lecture.tags.includes(filter));
    }
    return lectures;
  }

  applySorting(lectures) {
    let priorityA = 0;
    const { sortBy, sortDirection } = this.state;

    return lectures.sort((a, b) => {
      const valA = a[sortBy] || Infinity;
      const valB = b[sortBy] || Infinity;

      if (typeof valA === 'string') {
        priorityA = valA < valB ? -1 : 1;
      } else if (typeof valA === 'number') {
        priorityA = valA - valB;
      }

      if (priorityA === 0) {
        priorityA = a.title < b.title ? -1 : 1;
      }

      return sortDirection === 'asc' ? priorityA : priorityA * (-1);
    });
  }

  get lectures() {
    let lectures = this.props.lecturesStore.lectures$;
    lectures = this.applyFilters(lectures);
    return this.applySorting(lectures);
  }

  onChangeTags = (option) => {
    this.setState({ filter: option.value });
  }

  onChangeSortBy = (option) => {
    this.setState({ sortBy: option.value });
  }

  onChangeSortDirection = (option) => {
    this.setState({ sortDirection: option.value });
  }
}



// WEBPACK FOOTER //
// ./src/pages/lectures/lectures.page.jsx